import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import AllRequests from "../../../components/leave/requests/AllRequests";

const DepartmentalLeaveRequests = () => {
    const location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const queryParams = new URLSearchParams(location.search);
    
    const department = queryParams.get('label');
    const departmentslug = segments?.[2];

    return (
        <div className="leave-requests">
            <div className="page-header">
                <div className="title">
                    <h1>Leave Requests</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to='/leaves/my-leave'>Leave</NavLink>
                        </li>
                        <li>
                            <NavLink to="/leaves/requests">Requests</NavLink>
                        </li>
                        <li>
                            <span>{department}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <AllRequests departmentslug={departmentslug} />
        </div>
    )
}

export default DepartmentalLeaveRequests;